import { useLocation } from '@remix-run/react';

import useGlobalModals from '~/components/GlobalModals/hooks/useGlobalModals';
import { COMMUNITY_ROUTES } from '~/constants/community';
import { NectarPageBlock } from '~/utils/nectarPageBlock';

import { useCommunityMembership } from './useCommunityMembership';

export const useOpenCommunitySearch = (): (() => void) => {
  const { pathname } = useLocation();
  const { handleOpenModal } = useGlobalModals();
  const { isMember, openJoinModal } = useCommunityMembership();

  return () => {
    if (!isMember) {
      openJoinModal(NectarPageBlock.CommunitySidebarSearch);
      return;
    }
    if (pathname === COMMUNITY_ROUTES.search) return;
    handleOpenModal('search');
  };
};
